export enum AppEnv {
  Production = 'prod',
  Development = 'dev',
}

export interface AppConfig {
  env: AppEnv;
  versionTag: string;
  host: string;
  api: {
    tenantHost: string;
    globalHost: string;
  };
}

const appConfig: AppConfig = {
  env: (import.meta.env.VITE_ENV || import.meta.env.MODE) as AppEnv,
  versionTag: import.meta.env.VITE_APP_VERSION || '',
  host: import.meta.env.VITE_HOST || '',
  api: {
    tenantHost: import.meta.env.VITE_API_TENANT_HOST || '',
    globalHost: import.meta.env.VITE_API_HOST || '',
  },
};

export const getAppConfig: () => AppConfig = () => {
  return appConfig;
};

export function isEnv(env: AppEnv): boolean {
  return appConfig.env === env;
}
